import PropTypes from "prop-types";
import { Box, Typography, Stack } from "@mui/material";

import dayjs from "dayjs";

import CurrentRepaymentDateAttribute from "./CurrentRepaymentDateAttribute";
import { formatCurrency } from '../../../utils/formatCurrency';


function CurrentRepaymentDate({ liveAccount }) {

  return (
    <>
      <Box>
        <Typography sx={{ fontSize: 16, mb: 2 }}>
          Changing your repayment date is easy. Calculate your new repayment schedule below;
        </Typography>
      </Box>
      <Box>
        <Stack
          sx={{ width: { xs: "100%", sm: "75%" } }}
          spacing={2}
          direction={{
            xs: "column",
            md: "row",
          }}
        >
          {/* Left hand column */}
          <Box
            sx={{
              textAlign: "left",
              width: "100%",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Box>
              <CurrentRepaymentDateAttribute
                id="current-repayment-due-date"
                title="Current repayment due date:"
                value={dayjs(liveAccount?.contractualDueDate).format("DD/MM/YYYY")}
              />
            </Box>
            <Box sx={{ pt: 3 }}>
              <CurrentRepaymentDateAttribute
                id="current-repayment-amount"
                title="Current repayment amount:"
                value={formatCurrency(liveAccount?.amountDue)}
              />
            </Box>
          </Box>
          {/* End of left hand column */}

          {/* Right hand column */}
          <Box
            sx={{
              textAlign: "left",
              width: "100%",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Box>
              <CurrentRepaymentDateAttribute
                id="current-next-repayment-due-date"
                title="Current next repayment due date:"
                value={dayjs(liveAccount?.nextDueDate).format("DD/MM/YYYY")}
              />
            </Box>
            <Box sx={{ pt: 3 }}>
              <CurrentRepaymentDateAttribute
                id="current-loan-term-end-date"
                title="Current loan term end date:"
                value={dayjs(liveAccount?.contractEndDate).format("DD/MM/YYYY")}
              />
            </Box>
          </Box>
          {/* End of right hand column */}
        </Stack>
      </Box>    
    </>
  )
};

CurrentRepaymentDate.propTypes = {
  liveAccount: PropTypes.object.isRequired,
};

export default CurrentRepaymentDate;